import { service } from '@ember/service';

import Base from 'ember-cp-validations/validators/base';

export default class zxcvbnValidator extends Base {
  @service intl;

  _zxcvbn = null;

  async validate(value) {
    if (!this._zxcvbn) {
      let lib = await import('zxcvbn');
      this._zxcvbn = lib.default;
    }
    let predicate = this._zxcvbn(value);
    if (predicate.score < 3 && predicate.feedback.warning) {
      return this.translationLookup(predicate.feedback.warning);
    } else {
      return true;
    }
  }

  translationLookup(input) {
    switch (input) {
      case 'Straight rows of keys are easy to guess':
      case 'Short keyboard patterns are easy to guess':
        return this.intl.t('validations.errors.password_spatial');

      case 'Repeats like "aaa" are easy to guess':
      case 'Repeats like "abcabcabc" are only slightly harder to guess than "abc"':
        return this.intl.t('validations.errors.password_repeat');

      case 'Sequences like abc or 6543 are easy to guess':
        return this.intl.t('validations.errors.password_sequence');

      case 'Recent years are easy to guess':
      case 'Dates are often easy to guess':
        return this.intl.t('validations.errors.password_date');

      case 'This is a top-10 common password':
      case 'This is a top-100 common password':
        return this.intl.t('validations.errors.password_common');

      case 'This is a very common password':
      case 'This is similar to a commonly used password':
      case 'A word by itself is easy to guess':
      case 'Names and surnames by themselves are easy to guess':
      case 'Common names and surnames are easy to guess':
        return this.intl.t('validations.errors.password_dictionary');
    }
  }
}
